import getExamSectionMap from "./getExamSectionMap";

const addSectionsToExamArray = (
  examArray,
  examSections,
  previousCustomExams
) => {
  let examSectionsMap = getExamSectionMap(examSections);
  for (let i = 0; i < examArray.length; ++i) {
    examArray[i].sections = [];
    examArray[i].sectionIds.forEach((sectionId) => {
      if (examSectionsMap[sectionId]) {
        examArray[i].sections.push(examSectionsMap[sectionId]);
      }
    });
  }
  for (let i = 0; i < previousCustomExams.length; ++i) {
    previousCustomExams[i].sections = [];
    previousCustomExams[i].sectionIds.forEach((sectionId) => {
      if (examSectionsMap[sectionId]) {
        previousCustomExams[i].sections.push(examSectionsMap[sectionId]);
      }
    });
  }
  return;
};

export default addSectionsToExamArray;
